module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid flex-grid--wrap a-form-inputs"
  }, [_c('form', {
    staticClass: "m-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [(_vm.showNames) ? _c('control', {
    attrs: {
      "name": 'dependent_name_' + _vm.index,
      "label": "Dependant Name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theDependant.name),
      expression: "theDependant.name"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "field-control",
      rawName: "v-field-control:dependent_name.required",
      value: ({
        type: 'text',
        rules: 'name'
      }),
      expression: "{type:'text', rules:'name'}",
      arg: "dependent_name",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "dependent_name",
      "type": "text",
      "id": 'dependent_name_' + _vm.index,
      "maxlength": "100",
      "required": ""
    },
    domProps: {
      "value": (_vm.theDependant.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.theDependant, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('dependent_name')
    }
  }, [_vm._v("\n                    The dependant's name is required and must be a valid name\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "name": 'date_of_birth_' + _vm.index,
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:dependant_date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "dependant_date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.theDependant.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.theDependant, "dateOfBirth", $$v)
      },
      expression: "theDependant.dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('dependant_date_of_birth')
    }
  }, [_vm._v("\n                    The dependant's date of birth is required and must be in the format DD/MM/YYYY\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "name": 'dependant_gender' + _vm.index,
      "label": "Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theDependant.gender),
      expression: "theDependant.gender"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "dependant_gender",
      "id": 'dependant_gender' + _vm.index,
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.theDependant, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.update]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('dependant_gender')
    }
  }, [_vm._v("\n                    The dependant gender is required\n                ")])], 1), _vm._v(" "), _c('life-expectancy', {
    attrs: {
      "label": "Dependant's Life Expectancy",
      "person": _vm.theDependant,
      "type": 'dependant',
      "index": this.index,
      "stepValid": _vm.stepValid,
      "assumed-settlement": _vm.claimDetails('assumedSettlement')
    },
    on: {
      "update": _vm.updateLife
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "label": "Age at Deceased’s Date of Death",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.ageAtDeceasedDod
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Current Age",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.age
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Age at Assumed Settlement",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.ageAtAssumedSettlement
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Age at Deceased's End of Life",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.ageAtDeceasedButForDod
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "End of Dependency",
      "for": "end_of_dependency"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.dependency.date
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container a-form-inputs--years"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endOfDependencyDuration),
      expression: "endOfDependencyDuration"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "name": "end_of_dependency",
      "min": "0.1",
      "step": "0.01",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.endOfDependencyDuration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endOfDependencyDuration = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('end_of_dependency') || !_vm.endOfDependencyValid()
    }
  }, [_vm._v("\n                            There must be a period of dependency\n                        ")])], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-8"
  }, [_c('button', {
    staticClass: "a-button u-margin-top-0 u-margin-bottom-0",
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": _vm.deleteThisDependant
    }
  }, [_vm._v("Delete\n            Dependant\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e6d5b6b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/dependency/steps/dependants/Dependant.vue
// module id = 1715
// module chunks = 0